<div class="container">
  <div class="flex flex-col md:flex-row">
    <div class="w-full py-v-spacing sm:px-v-spacing max-w-container mx-auto">
      @if (hubspotContent) {
        <div class="wysiwyg" [innerHtml]="hubspotContent"></div>
      }
    </div>
    <div class="w-full py-v-spacing sm:px-v-spacing max-w-container mx-auto">
      @if (isAceHubspotType) {
        <div class="lg:w-4/6 mx-auto w-full" id="hubspot"></div>
      }
      @if (!isAceHubspotType) {
        @for (form of multiform; track form; let i = $index) {
          <div [hidden]="form.id !== 'hubspot' + currentStep" class="lg:w-4/6 mx-auto w-full" id="{{ form.id }}"></div>
        }
      }
    </div>
  </div>
</div>
